// Components
import CommonToolbar from "@Layouts/components/Tables/DataSmartTable/toolbar/CommonToolbar";
import DataSmartTable from "@Layouts/components/Tables/DataSmartTable";
import NoRowsOverlay from "@Layouts/components/Tables/DataSmartTable/additional/NoRowsOverlay";

// MUI
import { useGridApiRef } from "@mui/x-data-grid-premium";

export default function OemEmployees(props) {
	const apiRef = useGridApiRef();

	return (
		<DataSmartTable
			apiRef={apiRef}
			columns={props.columns || []}
			rows={props.data || []}
			headerHeight={28}
			rowHeight={25}
			enableCustomScrollbars
			hideFooter
			disableColumnMenu
			disableRowSelectionOnClick
			disableMultipleRowSelection
			checkboxSelection={false}
			columnVisibilityModel={{
				_id: false,
			}}
			slots={{
				toolbar: CommonToolbar,
				noRowsOverlay: NoRowsOverlay,
			}}
			slotProps={{
				toolbar: {
					filter: {
						hide: false,
					},
					search: {
						data: props.data || [],
						hide: false,
						disabled: false,
					},
				},
				noRowsOverlay: {
					title: "No Employees Metrics data",
				},
			}}
			customProps={{
				tableContainerStyle: { height: "100%", width: "100%" },
				tableClassName: {
					"functional-table": true,
					"!z-[1]": true,
					"[&_.MuiDataGrid-main]:!mt-[20px]": true,
					"[&_.toolbar-actions]:!right-0": true,
				},
				hide: false,
			}}
		/>
	);
}
